export default {
  title: 'VoluntHUB'
};
